
var template = require('./index.html')
var locales = require('./locales.json')
var t = require('../translate')

module.exports = {
  props: ['products'],
  replace: true,
  template: template,
  data: data,
  methods: {
    slideto: require('../animation/slideto')
  }
}

function data () {
  return {
    title: t(locales, 'title')
  }
}


// WEBPACK FOOTER //
// ./lib/overview/index.js